import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import spandanOneLogo from "../../assets/images/logos/spandan-logo-2.svg";
import { renderLegalBody } from "../../components/LegalLinks";

const LegalPage = ({ doc }) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [doc]);

  return (
    <>
      <Helmet>
        <title>{doc.title} - Spandan One</title>
      </Helmet>

      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: "var(--app-surface)",
          color: "var(--app-text)",
          px: { xs: 2.5, sm: 4 },
          py: { xs: 4, md: 6 },
        }}
      >
        <Box sx={{ maxWidth: 860, mx: "auto" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 4,
            }}
          >
            <Box
              component="img"
              src={spandanOneLogo}
              alt="Spandan One"
              sx={{ height: 56 }}
            />
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() =>
                window.history.length > 1 ? navigate(-1) : navigate("/login")
              }
              sx={{ textTransform: "none", fontWeight: 600, color: "#5B5BE0" }}
            >
              Back
            </Button>
          </Box>

          <Typography
            component="h1"
            sx={{
              fontSize: { xs: "24px !important", sm: "30px !important" },
              fontWeight: 700,
              mb: 1,
            }}
          >
            {doc.title}
          </Typography>
          {doc.meta.map((m) => (
            <Typography
              key={m}
              sx={{ fontSize: 13, color: "var(--app-text-muted)" }}
            >
              {m}
            </Typography>
          ))}

          <Box sx={{ mt: 3 }}>{renderLegalBody(doc.body)}</Box>
        </Box>
      </Box>
    </>
  );
};

export default LegalPage;
